import { APP_CONFIG } from '../../config/app.config';

export type ColorVariant = 'primary' | 'error' | 'success' | 'grey';

export const addTransparency = (color: string, opacity: number = 0.1) => {
  // If color is already in rgba format, just update the opacity
  if (color.startsWith('rgba')) {
    return color.replace(/[\d.]+\)$/g, `${opacity})`);
  }
  
  // If color is hex, convert to rgba
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // For any other format, wrap in rgba
  return `rgba(${color}, ${opacity})`;
};

export const darkenColor = (color: string, amount: number = 10) => {
  return `color-mix(in srgb, ${color} ${100 - amount}%, black)`;
};
